import { Injectable, inject } from '@angular/core';
import { type TagSettingInformation, type TagEntityType, type TagInformation } from '@models/tag-models';
import { type Observable } from 'rxjs';
import { map, share, tap } from 'rxjs/operators';
import { ApplicationCacheService, UpdateCategory } from '../application-cache.service';
import { UrlService } from '../url.service';
import { HttpClientService } from '@services/http-client.service';

@Injectable()
export class TagsService {
  private readonly url = inject(UrlService);
  private readonly applicationCacheService = inject(ApplicationCacheService);
  private readonly http = inject(HttpClientService);

  protected listAll(): Observable<TagInformation[]> {
    return this.applicationCacheService.getFromCache(UpdateCategory.Tags, this.url.tagList);
  }

  list(...entityTypes: TagEntityType[]): Observable<TagInformation[]> {
    return this.listAll().pipe(map(tags => tags.filter(x => entityTypes.includes(x.entityType))));
  }

  listForSettings() {
    return this.http.get<TagSettingInformation[]>(this.url.tagSettingsList);
  }

  delete(id: Id) {
    return this.http.delete<void>(this.url.tagDelete.replace('$0', id.toString())).pipe(
      tap(_ => {
        this.clearCache();
      }),
      share()
    );
  }

  private clearCache() {
    if (this.applicationCacheService) {
      this.applicationCacheService.clearCategory(UpdateCategory.Tags);
    }
  }
}
